// Module
var code = "<div title=\"{{vm.title|translate}}\" class=\"level-slider\"> <input type=\"range\" ng-model=\"vm.level\" min=\"{{vm.minLevel}}\" max=\"{{vm.maxLevel}}\" step=\"1\" list=\"ticks\" ng-change=\"vm.change()\"/> <datalist id=\"ticks\"> <option ng-repeat=\"tick in vm.ticks\"> {{tick}} </option> </datalist> </div>";
// Exports
module.exports = code;